import type { GlobEnvConfig } from '/#/config';
import { watch } from 'vue';
import pkg from '../../package.json';
import { getConfigFileName } from '../../build/getConfigFileName';

export function getCommonStoragePrefix() {
  const { VITE_GLOB_APP_SHORT_NAME } = getAppEnvConfig();
  return `${VITE_GLOB_APP_SHORT_NAME}__${getEnv()}`.toUpperCase();
}

// Generate cache key according to version
export function getStorageShortName() {
  return `${getCommonStoragePrefix()}${`__${pkg.version}`}__`.toUpperCase();
}

export function getAppEnvConfig() {
  const ENV_NAME = getConfigFileName(import.meta.env);

  const ENV = (import.meta.env.DEV
    ? // Get the global configuration (the configuration will be extracted independently when packaging)
      (import.meta.env as unknown as GlobEnvConfig)
    : window[ENV_NAME as any]) as unknown as GlobEnvConfig;

  const {
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_APP_SHORT_NAME,
    VITE_GLOB_API_URL_PREFIX,
    VITE_GLOB_APP_OPEN_SSO,
    VITE_GLOB_APP_OPEN_QIANKUN,
    VITE_GLOBE_APP_CAS_BASE_URL,
    VITE_GLOB_ONLINE_VIEW_URL,
    VITE_API_LOCAL,
  } = ENV;

  if (!/^[a-zA-Z\_]*$/.test(VITE_GLOB_APP_SHORT_NAME)) {
    // warn(
    //   `VITE_GLOB_APP_SHORT_NAME Variables can only be characters/underscores, please modify in the environment variables and re-running.`
    // );
  }

  const filter2d3dApp = ['shanshe2', 'shanshe-enterprise'];
  let baseUrl = window.ENV_CONFIG['baseUrl'];
  const searchParams = new URLSearchParams(window.location.search);
  const app = searchParams.get('app');
  // 仅有工作台和闪设企业版需要区分3dAgent和2dAgent
  if (
    window.location.hostname.split('.')[0] === '3d' &&
    filter2d3dApp.some((item) => item === app)
  ) {
    baseUrl = window.ENV_CONFIG['baseUrl3D'];
  }

  return {
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_API_URL: VITE_API_LOCAL ? '/api' : `${baseUrl}/v3`,
    VITE_GLOB_APP_SHORT_NAME,
    VITE_GLOB_API_URL_PREFIX,
    VITE_GLOB_APP_OPEN_SSO,
    VITE_GLOB_APP_OPEN_QIANKUN,
    VITE_GLOBE_APP_CAS_BASE_URL,
    VITE_GLOB_DOMAIN_URL: VITE_API_LOCAL ? '/api' : window.ENV_CONFIG['baseUrl'],
    VITE_GLOB_ONLINE_VIEW_URL,
  };
}

/**
 * @description: Development mode
 */
export const devMode = 'development';

/**
 * @description: Production mode
 */
export const prodMode = 'production';

/**
 * @description: Get environment variables
 * @returns:
 * @example:
 */
export function getEnv(): string {
  return import.meta.env.MODE;
}

/**
 * @description: Is it a development mode
 * @returns:
 * @example:
 */
export function isDevMode(): boolean {
  return import.meta.env.DEV;
}

/**
 * @description: Is it a production mode
 * @returns:
 * @example:
 */
export function isProdMode(): boolean {
  return import.meta.env.PROD;
}
